/**
 ** 加法函数，用来得到精确的加法结果
 ** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
 ** 调用：accAdd(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
const add = (arg1, arg2) => {
  var r1
  var r2
  var m
  var c
  try {
    r1 = dotBits(arg1)
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = dotBits(arg2)
  } catch (e) {
    r2 = 0
  }
  c = Math.abs(r1 - r2)
  m = Math.pow(10, Math.max(r1, r2))
  if (c > 0) {
    var cm = Math.pow(10, c)
    if (r1 > r2) {
      arg1 = parseInt(arg1.toString().replace('.', ''))
      arg2 = parseInt(arg2.toString().replace('.', '')) * cm
    } else {
      arg1 = parseInt(arg1.toString().replace('.', '')) * cm
      arg2 = parseInt(arg2.toString().replace('.', ''))
    }
  } else {
    arg1 = parseInt(arg1.toString().replace('.', ''))
    arg2 = parseInt(arg2.toString().replace('.', ''))
  }
  var r = parseFloat((arg1 + arg2) / m)
  return isNaN(r) ? 0 : r
}

/**
 ** 减法函数，用来得到精确的减法结果
 ** 说明：javascript的减法结果会有误差，在两个浮点数相减的时候会比较明显。这个函数返回较为精确的减法结果。
 ** 调用：accSub(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
const sub = (arg1, arg2) => {
  var r1
  var r2
  var m
  var n
  try {
    r1 = dotBits(arg1)
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = dotBits(arg2)
  } catch (e) {
    r2 = 0
  }
  /**
   * last modify by deeka //动态控制精度长度
   * @type {number}
   */
  m = Math.pow(10, Math.max(r1, r2))
  n = (r1 >= r2) ? r1 : r2

  var r = parseFloat(((arg1 * m - arg2 * m) / m).toFixed(n))
  return isNaN(r) ? 0 : r
}

/**
 ** 乘法函数，用来得到精确的乘法结果
 ** 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
 ** 调用：accMul(arg1,arg2)
 ** 返回值：arg1乘以 arg2的精确结果
 **/
const mul = (arg1, arg2) => {
  var m = 0
  var fixed = 2
  var s1 = arg1.toString()
  var s2 = arg2.toString()
  try {
    m += dotBits(arg1)
  } catch (e) {
  }
  try {
    m += dotBits(arg2)
  } catch (e) {
  }
  return parseFloat(Number(s1.replace('.', '')) * parseInt(s2.replace('.', '')) / Math.pow(10, m)).toFixed(fixed)
}
/**
 ** 除法函数，用来得到精确的除法结果
 ** 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
 ** 调用：accDiv(arg1,arg2)
 ** 返回值：arg1除以arg2的精确结果
 **/
const div = (arg1, arg2, fixed) => {
  var t1 = 0
  var t2 = 0
  var r1
  var r2
  try {
    t1 = dotBits(arg1)
  } catch (e) {
    console.error('error', e)
  }
  try {
    t2 = dotBits(arg2)
  } catch (e) {
    console.error('error', e)
  }
  r1 = parseInt((arg1 || 0).toString().replace('.', ''))
  r2 = parseInt((arg2 || 1).toString().replace('.', ''))
  return parseFloat((r1 / r2) * Math.pow(10, t2 - t1)).toFixed(fixed)
}

function dotBits (arg) {
  arg = arg || '0'
  return arg.toString().split('.')[1] ? arg.toString().split('.')[1].length : 0
}

function uuid () {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4'
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
  s[8] = s[13] = s[18] = s[23] = ''

  var uuid = s.join('')
  return uuid
}
export default {add, sub, mul, div, uuid}
